// Build-time cache buster. Bumped on every code change so production
// gets a brand-new main.<hash>.js filename — this is the most reliable
// way to defeat stale Cloudflare edge caches that pin a JS URL to a
// wrong (HTML) response.
export const BUILD_ID = '2026-07-16-flexible-schedule-mode';
